import ReactGA from 'react-ga'
import React from 'react'
import * as column from './columns'
import moment from 'moment'
import { Table, DatePicker, Alert } from 'antd'
import Graph from './Graph'
import { fetchPrestartsForDateRange, subscribeFulcrumRefresh } from '../../utilities/fulcrumData'

const defaultDateFrom = () => moment().startOf('day').subtract(10, 'day').format('YYYY-MM-DD')
const defaultDateTo = () => moment().format('YYYY-MM-DD')

class Prestarts extends React.Component {
  constructor() {
    super()
    this.state = {
      dateFrom: defaultDateFrom(),
      dateTo: defaultDateTo(),
      prestarts: [],
      loading: false,
      error: null,
    }
    this.loadCancelled = false
    this.unsubscribeRefresh = null
    this.dateSelectionUpdate = this.dateSelectionUpdate.bind(this)
  }

  componentDidMount() {
    ReactGA.pageview('/prestarts')
    this.unsubscribeRefresh = subscribeFulcrumRefresh(() => this.loadPrestarts())
    this.loadPrestarts()
  }

  componentWillUnmount() {
    this.loadCancelled = true
    if (this.unsubscribeRefresh) {
      this.unsubscribeRefresh()
    }
  }

  loadPrestarts() {
    const { dateFrom, dateTo } = this.state
    this.setState({ loading: true, error: null })

    fetchPrestartsForDateRange(dateFrom, dateTo)
      .then((prestarts) => {
        if (!this.loadCancelled) {
          this.setState({ prestarts, loading: false })
        }
      })
      .catch((err) => {
        if (!this.loadCancelled) {
          this.setState({ error: err, loading: false })
        }
      })
  }

  dateSelectionUpdate(dates, dateStrings) {
    if (!dates || !dates[0] || !dates[1]) {
      return
    }
    this.setState(
      {
        dateFrom: moment(dateStrings[0], 'DD-MM-YYYY').format('YYYY-MM-DD'),
        dateTo: moment(dateStrings[1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
      },
      () => this.loadPrestarts()
    )
  }

  render() {
    const { prestarts, loading, error, dateFrom, dateTo } = this.state
    const prestartData = []
    let countOperational = 0
    let countMaintenance = 0
    let countService = 0

    for (let i = 0; i < prestarts.length; i++) {
      const record = prestarts[i]
      const formValues = record.form_values || {}
      let status

      if (record.status === 'No Work Required') {
        status = 'Operational'
        countOperational++
      } else if (record.status === 'Work Required') {
        status = 'Maintenance Required'
        countMaintenance++
      }

      let fixIt = ''
      if (formValues['38e9']) {
        const str = formValues['38e9'].replace(/,/g, '')
        fixIt = str
        if (formValues['38e9'].includes('Service Due.')) {
          countService++
          status = 'Service Due'
        }
      }

      const priorityField = formValues[2155]
      const priority =
        (priorityField && priorityField.choice_values && priorityField.choice_values[0]) || ''

      const comments = formValues.c501 || ''

      const fromField = formValues['947b']
      const psFrom =
        (fromField && fromField.choice_values && fromField.choice_values[0]) || ''

      prestartData.push({
        psID: record.id,
        psDate: formValues.fdf9,
        psStatus: status,
        psOn: formValues['94a5'],
        psComments: comments,
        psFix: fixIt,
        psFrom,
        psPriority: priority,
      })
    }

    prestartData.sort((a, b) => (a.psDate > b.psDate ? -1 : 1))

    return (
      <div>
        <h1>Prestarts</h1>
        <h4>The default date range is from the previous 10 days.</h4>
        <DatePicker.RangePicker
          ranges={{
            'Previous 10 Days': [moment().startOf('day').subtract(10, 'day'), moment()],
            'Previous 30 Days': [moment().startOf('day').subtract(30, 'day'), moment()],
            'This Year': [moment().startOf('year'), moment().endOf('year')],
          }}
          value={[moment(dateFrom), moment(dateTo)]}
          format="DD-MM-YYYY"
          onChange={this.dateSelectionUpdate}
          style={{ padding: '20px 0' }}
        />
        {error ? (
          <Alert
            type="error"
            showIcon
            message="Could not load prestarts"
            description={error.message || 'Please try again.'}
            style={{ marginBottom: 16 }}
          />
        ) : null}
        <Graph data={[countOperational, countService, countMaintenance]} />
        <h2>Details</h2>
        <Table
          loading={loading}
          pagination={false}
          id="boresTableTwo"
          className="tableResizer"
          columns={column.prestartList}
          rowClassName={(record) => record.psStatus}
          dataSource={prestartData}
          rowKey="psID"
          size="small"
        />
      </div>
    )
  }
}

export default Prestarts
